<template>
    <div>
      <vs-popup title="جزئیات تراکنش" :active.sync="popupDetailActive" id="toman-history-detail">

        <vs-alert color="danger" active="true" v-if="!isLoading && Transaction.reason && Transaction.status=='reject'"
                  class="mb-4" icon-pack="feather" icon="icon-alert-triangle">
          <b>{{$t('Reason for rejection')}}:</b> {{Transaction.reason}} {{$t('The amount is also returned to your wallet')}}
        </vs-alert>

        <div class="vx-row">
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-1">
              شناسه تراکنش:
            </div>
            <div class="vx-col text-primary">
              <span v-if="!isLoading && Transaction">#{{Transaction.id}}</span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-1">
              وضعیت:
            </div>
            <div class="vx-col">
               <span v-if="!isLoading && Transaction">
                <vs-chip color="success" v-if="Transaction.status == 'success'">{{$t(Transaction.status)}}</vs-chip>
                <vs-chip color="warning" v-if="Transaction.status == 'pending'">{{$t(Transaction.status)}}</vs-chip>
                <vs-chip color="danger" v-if="Transaction.status == 'reject' || Transaction.status == 'unsuccessful'">{{$t(Transaction.status)}}</vs-chip>
                <vs-chip color="dark" v-if="Transaction.status == 'return'">{{$t(Transaction.status)}}</vs-chip>
              </span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-1">
              تاریخ ثبت:
            </div>
            <div class="vx-col vazir ">
              <span v-if="!isLoading && Transaction">{{Transaction.DateTime}}</span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-2">
              نوع:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && Transaction" class="flex items-center">
                <div class="h-3 w-3 rounded-full mr-1" :class="'bg-' + (Transaction.type == 'deposit'? 'success' : 'danger' )"></div>
                {{$t(Transaction.type)}}
              </span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-1">
              مبلغ:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && Transaction">{{Transaction.amount.toLocaleString('en-US')}} {{$t('Toman')}}</span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-1">
              موجودی بعد از تراکنش:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && Transaction">{{Transaction.stock.toLocaleString('en-US')}} {{$t('Toman')}}</span>
            </div>
          </div>

          <div class="vx-col lg:w-1/2 w-full flex mb-3"  v-if="!isLoading && Transaction && Transaction.PaymentGateway">
            <div class="vx-col mr-1">
              درگاه پرداخت:
            </div>
            <div class="vx-col">
              <span>{{Transaction.PaymentGateway}} </span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3"  v-if="!isLoading && Transaction && Transaction.trace_number">
            <div class="vx-col mr-1">
              شماره پیگیری درگاه:
            </div>
            <div class="vx-col" v-clipboard:copy="Transaction.trace_number" v-clipboard:success="onCopy" v-clipboard:error="onError">
              <vs-tooltip color="success" :text="$t('click for copy')">
                <span><i class="feather icon-copy"></i> {{Transaction.trace_number}} </span>
              </vs-tooltip>
            </div>
          </div>
          <div class="vx-col lg:w-2/2 w-full flex mb-3"  v-if="!isLoading && Transaction && Transaction.depositTrackId">
            <div class="vx-col mr-1">
              شماره پیگیری واریز:
            </div>
            <div class="vx-col" v-clipboard:copy="Transaction.depositTrackId" v-clipboard:success="onCopy" v-clipboard:error="onError">
              <vs-tooltip color="success" :text="$t('click for copy')">
                <span><i class="feather icon-copy"></i> {{Transaction.depositTrackId}} </span>
              </vs-tooltip>
            </div>
          </div>

          <div class="vx-col lg:w-2/2 w-full flex mb-3"  v-if="!isLoading && Transaction">
            <div class="vx-col mr-2">
              توضیحات تراکنش:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && Transaction">{{Transaction.description ? Transaction.description : ' - - - - - '}}</span>
            </div>
          </div>

          <vs-divider v-if="!isLoading && Transaction.receipt"/>
          <div v-if="!isLoading && Transaction.receipt" class="vx-col w-full mb-3">
            <p>
              مشخصات فیش ثبت شده:
            </p>
            <vs-table stripe :data="Transaction.receipt.via" :noDataText="$t('No data Available')">
              <template>
                <vs-tr>
                  <vs-td class="whitespace-no-wrap">
                   تاریخ و زمان ثبت
                  </vs-td>
                  <vs-td class="whitespace-no-wrap vazir">
                    {{ Transaction.receipt.dateTime }}
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td class="whitespace-no-wrap">
                    {{$t('Tracking Code')}}
                  </vs-td>
                  <vs-td class="whitespace-no-wrap vazir">
                    {{ Transaction.receipt.trackingCode }}
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td class="whitespace-no-wrap">
                    {{$t('How to deposit')}}
                  </vs-td>
                  <vs-td class="whitespace-no-wrap vazir">
                    {{ Transaction.receipt.via }}
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td class="whitespace-no-wrap">
                    {{$t('Payee')}}
                  </vs-td>
                  <vs-td class="whitespace-no-wrap">
                    {{ Transaction.receipt.payee.account_number }} {{Transaction.receipt.payee.name_bank}}
                    <br>
                    {{ Transaction.receipt.payee.iban_number }}
                  </vs-td>
                </vs-tr>
                <vs-tr v-if="Transaction.receipt.photo">
                  <vs-td class="whitespace-no-wrap">
                    {{$t('Photo Receipt')}}
                  </vs-td>
                  <vs-td class="whitespace-no-wrap">
                    <img :src="srcFile" width="100%">
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>

          <div class="vx-col w-full" v-if="!isLoading && Transaction && Transaction.status == 'return'">
            <vs-divider/>
            <vs-alert class="" color="warning" active="true" >
            شما با کارتی غیر از کارت های تایید شده پرداخت کرده اید و این تراکنش مورد تایید نیست. مبلغ شما حداکثر پس از 72 ساعت به همان کارتی که پرداخت شده است به صورت اتوماتیک و توسط درگاه عودت میشود.
            </vs-alert>
          </div>
          <div class="vx-col w-full" v-else-if="!isLoading && Transaction && Transaction.status == 'unsuccessful'">
            <vs-divider/>
            <vs-alert class="" color="danger" active="true" >
              جهت پیگیری وضعیت این تراکنش با پشتیبانی در ارتباط باشید.
            </vs-alert>
          </div>

        </div>
      </vs-popup>
    </div>
</template>

<i18n locale="fa">
{
  "Tracking Code":"کد پیگیری"
  ,"How to deposit":"نحوه واریز"
  ,"Payee":"اطلاعات حساب مقصد"
  ,"The amount is also returned to your wallet":"همچنین مبلغ به کیف پول شما برگردانده شده است"
}
</i18n>
<script>
import axios from "../../../../axios";

export default {
  name: 'TomanDetail',
  props: {
    popupDetail: {
      type: Boolean,
      required: true
    },
    idTransaction:{
      required: true
    }
  },
  data () {
    return {
      popupDetailActive: this.popupDetail,
      isLoading: false,
      Transaction: null,
      srcFile:null
    }
  },
  methods:{
    getData(){
      const self = this;
      axios.post('/history/internal-transaction/'+ this.idTransaction)
        .then(function (response) {
          self.Transaction = response.data.transaction
          if(self.Transaction.receipt.photo)
            self.getFile(self.Transaction.receipt.photo,'srcFile')
          self.isLoading = false;
      }).catch(function (error) { console.log(error); self.isLoading = false;})
    }
  },
  watch: {
    popupDetail (newVal, oldVal) { // watch it
      this.popupDetailActive = newVal
      this.$emit('popupDetailChange', newVal)
    },
    popupDetailActive (newVal, oldVal) { // watch it
      this.popupDetailActive = newVal
      this.$emit('popupDetailChange', newVal)
    },
    isLoading(value){
      if(value){
        this.$vs.loading({
          container: '#toman-history-detail',
          type: 'radius',
          scale: 1.65
        })
      }else
        this.$vs.loading.close('#toman-history-detail > .con-vs-loading')
    },
  },
  created() {
    this.isLoading = true;
    this.getData();
  }
}
</script>

<style scoped>

</style>
